<template>
<span>
  <span v-if="link && !button">
    <a href="" v-on:click="download">{{ text }}</a>
  </span>
  <span v-if="button">
    <button
      class="btn btn-secondary"
      v-on:click="download"
    >
      {{ text }}
    </button>
  </span>
</span>
</template>

<script>
export default {
  data () {
    return {}
  },

  props: {
    link: {
      type: String,
      default: 'true'
    },

    button: {
      type: String,
      default: null
    },

    text: {
      type: String,
      default: 'Download'
    },

    email: {
      type: [ Number, String ],
      default: undefined
    },

    emailId: {
      type: [ Number, String ],
      default: undefined,
      required: true
    },

    emailType: {
      type: String,
      default: 'newsletter'
    },

    attachmentId: {
      type: [ Number, String ],
      default: undefined,
      required: true
    }
  },

  methods: {
    download (e) {
      e.preventDefault()

      this.$http.get(
        this.apiUrl('/' + this.emailType + '_attachments/' + this.attachmentId + '/download', true),
        {
          responseType: 'blob'
        }
      ).then((response) => {
        let headers = response.headers

        let blob = new Blob([response.bodyBlob], {
          type: headers['Content-type']
        })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = response.headers.get('filename')
        link.click()
      }, this.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailAttachmentDownload.vue